import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { EQuestionType, QuestionType } from 'src/app/models/questionType.model';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MenuQuestionComponent } from '../menu-question/menu-question.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { TabularQuestion } from 'src/app/models/TabularQuestion.model';
import { EStatus } from 'src/app/models/EnumStatus';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { QuestionItemComponent } from './question-item/question-item.component';
import { ModularQuestion } from 'src/app/models/modularQuestion.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { ToggleComponent } from 'src/app/shared/components/toggle/toggle.component';
import { UuidService } from 'src/app/services/uuid.service';
import { map, startWith, tap } from 'rxjs';

@Component({
    selector: 'que-questions-group',
    imports: [CommonModule, QuestionItemComponent, ReactiveFormsModule, TranslateDirective, TranslatePipe, MenuQuestionComponent, TranslateDirective, TranslatePipe, ToggleComponent],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: QuestionsGroupComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: QuestionsGroupComponent,
            multi: true
        }
    ],
    templateUrl: './questions-group.component.html',
    styleUrls: ['./questions-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionsGroupComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() index?: number;
  @Output() focusEvent = new EventEmitter<boolean>();

  #builder = inject(FormBuilder);
  #uuidService = inject(UuidService);

  questionForm = this.#builder.group({
    id: [-1],
    type: new FormControl<QuestionType>({ id: -1, name: 'sds', category: -1, image: "" }),
    title: new FormControl<string>(''),
    text: new FormControl<string>('', [Validators.required]),
    requierd: new FormControl<boolean>(false),
    toNum: new FormControl<number | null>(null),
    collectionQuestionId: new FormControl<number | null>(null),
    modularQuestions: this.#builder.array<ModularQuestion>([]),
    apiExposureFieldName: new FormControl<string|null>(null),
  });
  orginalQuestion?: Question;
  // check = toSignal(this.questionForm.controls.modularQuestions.valueChanges);
  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;
  apiExposureFieldNameFill$ = toSignal(this.questionForm.valueChanges.pipe(map(value => value.apiExposureFieldName != null&&value.apiExposureFieldName != undefined),));
  isSmartQuestion$ = toSignal(this.questionForm.valueChanges.pipe(map(value => value.collectionQuestionId != null),));
  // isSmartQuestion$ = toSignal(this.questionForm.valueChanges.pipe(map(value => value.apie != null),));

  ngOnInit(): void {
    this.questionForm.valueChanges.subscribe(question => {
      if (this.registerOnChangeCallback) {

        this.registerOnChangeCallback({ ...this.orginalQuestion, ...question });
      }
    });
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.questionForm.valid) {
      return null;
    }
    return { 'optionsValue': "not-valid" }
  }
  writeValue(obj: Question): void {
    this.orginalQuestion = obj;
    if (obj.modularQuestions && !this.questionForm.controls.modularQuestions.length) {
      obj.modularQuestions.forEach(mq => {
        this.questionForm.controls.modularQuestions.push(new FormControl<ModularQuestion>(mq))
      })
    }
    this.questionForm.patchValue({ ...obj });
    //this.onValidationChangeCallBack();xxx
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  addModularQuestion() {
    this.questionForm.controls.modularQuestions.push(new FormControl<ModularQuestion>({ guid: this.#uuidService.generateUUID(), type: { id: EQuestionType.Fill, name: "fill", en: "Fill In the Blank", title: "שדה מילוי", image: "fill.svg" }, status: EStatus.Created },))
  }
  deleteModularQuestion(index: number) {
    this.questionForm.controls.modularQuestions.removeAt(index);
  }

  toggle(bool: boolean) {
    if (bool) {
      this.questionForm.controls.toNum.setValue(6);
    } else {
      this.questionForm.controls.toNum.setValue(null);
    }

  }
}

